module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "SP"
  }), _vm._v(" "), _c('p', {
    staticClass: "FMEP"
  }, [_c('span', {
    staticClass: "ePub-BI"
  }, [_vm._v("We once lived rooted")])]), _vm._v(" "), _c('p', {
    staticClass: "FMEP"
  }, [_c('span', {
    staticClass: "ePub-BI"
  }, [_vm._v("Like the ancient olive trees.")])]), _vm._v(" "), _c('p', {
    staticClass: "FMEP"
  }, [_c('span', {
    staticClass: "ePub-BI"
  }, [_vm._v("Now we’re birds")])]), _vm._v(" "), _c('p', {
    staticClass: "FMEP"
  }, [_c('span', {
    staticClass: "ePub-BI"
  }, [_vm._v("Nesting on songs")])]), _vm._v(" "), _c('p', {
    staticClass: "FMEP"
  }, [_c('span', {
    staticClass: "ePub-BI"
  }, [_vm._v("About homes we miss.")])]), _vm._v(" "), _c('p', {
    staticClass: "FMEP"
  }, [_c('span', {
    staticClass: "ePub-BI"
  }, [_vm._v("Storms and distances")])]), _vm._v(" "), _c('p', {
    staticClass: "FMEP"
  }, [_c('span', {
    staticClass: "ePub-BI"
  }, [_vm._v("Decide our address.")])]), _vm._v(" "), _c('p', {
    staticClass: "FMEPC"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("—"), _c('a', {
    attrs: {
      "href": "http://us.macmillan.com/author/ibtisambarakat?utm_source=ebook&utm_medium=adcard&utm_term=ebookreaders&utm_content=ibtisambarakat_authorpage_macdotcom&utm_campaign=9780374302535",
      "target": "_blank"
    }
  }, [_vm._v("Ibtisam Barakat")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-542f3a64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 75
// module chunks = 0